import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UsePlaylistSongsProps {
  playlistId: string;
  offset?: number;
  limit?: number;
}

export const usePlaylistSongs = ({ playlistId, offset = 0, limit = 50 }: UsePlaylistSongsProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();

  const query = useTRPCQuery(
    trpcMusicAPI.playlists.songs.queryOptions(
      { playlistId, offset, limit, ...shareTokenInput },
      { enabled: Boolean(playlistId) }
    )
  );

  return query;
};
